<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-simple-table class="table-layout">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="table-header-rank">Lộ trình làm việc</th>
                                <th class="table-header-user">Danh sách nhân sự</th>
                                <th class="table-header-action">Thao tác</th>
                            </tr>
                        </thead>
                        <template v-if="ministries.length">
                            <template 
                                v-for="ministry in ministries"
                                :id="'ministry-' + ministry.id"
                            >
                                <tbody 
                                    v-for="rank in ministry.ranks"  
                                    :id="'rank-' + rank.id"
                                    :key="'rank-no-data-' + rank.id"
                                >
                                    <tr v-if="rank.users && rank.users.length">
                                        <td :rowspan="parseInt(rank.users.length)" class="rank-info">
                                            <div>
                                                <div class="rank-name">
                                                    {{ rank.name }}
                                                </div>
                                                <div class="rank-path">
                                                    {{ ministry.name }}
                                                    <div v-for="(path, indexPath) in rank.path" :key="'path' + indexPath">
                                                        > {{ path }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="py-0">
                                            <div 
                                                v-for="user in rank.users" 
                                                :key="'user-' + user.id"
                                                :id="'user-' + user.id"
                                                class="py-2"
                                            >
                                                <div>
                                                    <span class="mr-3">                                                        
                                                        <img v-if="user.avatar" :src="user.avatar" />
                                                        <img v-else src="../../../assets/default-avatar.jpg" />
                                                    </span>
                                                    {{ user.fullName }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="rank-user-action py-0">
                                            <div 
                                                v-for="user in rank.users"
                                                :key="'user-action-' + user.id"
                                                class="py-3"
                                            >
                                                <v-checkbox
                                                    v-if="checkAuthorization('setting-rank_update')"
                                                    class="checkbox-user"
                                                    hide-details
                                                    color="#52B141"
                                                    v-model="user.check"
                                                    @change="selectUser(user)"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="!rank.users || rank.users.length == 0">
                                        <td>
                                            <div>
                                                <div class="rank-name">
                                                    {{ rank.name }}
                                                </div>
                                                <div class='rank-path'>
                                                    {{ ministry.name }}
                                                    <div v-for="(path, indexPath) in rank.path" :key="'path' + indexPath">
                                                        > {{ path }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="no-data">
                                            <div>
                                                Không có nhân viên
                                            </div>
                                        </td>
                                        <td>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </template>
                        <tbody v-else>
                            <tr>
                                <td colspan="1000">
                                    <common-no-result />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        ministries: {
            type: Array,
            default: () => {[]}
        }
    },

    methods: {
        selectUser(user) {
            if (user.check) {
                Bus.$emit('add-change-rank-user', user.id)
            } else {
                Bus.$emit('remove-change-rank-user', user.id)
            }
        }
    }
}
</script>

<style scoped>
/deep/ .v-data-table td {
    border-left: thin solid rgba(0, 0, 0, 0.12) !important;
    border-right: thin solid rgba(0, 0, 0, 0.12) !important;
    border-bottom: none !important;
    font-weight: 400;
    font-size: 16px;
    text-align: left;
    vertical-align: top !important;
    word-break: break-word;
}

/deep/ .v-data-table td.rank-info {
    padding: 12px 8px !important;
}

/deep/ .v-data-table td.no-data {
    vertical-align: middle !important;
}

/deep/ .v-data-table td.rank-user-action {
    text-align: center;
}

/deep/ .v-data-table tbody tr:last-child td {
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

/deep/ .v-data-table td[rowspan] {
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

/deep/ tbody:hover td[rowspan], tr:hover td {
   background: #DDDDDD; 
}

/deep/ .v-data-table tbody:last-child tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}

/deep/ .v-data-table tbody:last-child tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}

/deep/ .v-data-table th {
    font-weight: bold !important;
    font-size: 20px !important;
    border-left: thin solid rgba(0, 0, 0, 0.12) !important;
    border-right: thin solid rgba(0, 0, 0, 0.12) !important;
    border-top: thin solid rgba(0, 0, 0, 0.12) !important;
    background: #F3F2F9;
}

/deep/ .v-data-table th:first-child {
    border-top-left-radius: 10px;
}

/deep/ .v-data-table th:last-child {
    border-top-right-radius: 10px;
}

/deep/ .v-data-table th.table-header-rank {
    width: 30%;
}

/deep/ .v-data-table th.table-header-user {
    width: 60%
}

/deep/ .v-data-table th.table-header-action {
    width: 10%;
}

/deep/ .table-layout tbody tr {
    height: 60px !important;
}

/deep/ img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    transform: translateY(5px);
}

/deep/ .v-input--selection-controls.v-input.checkbox-user {
    margin: 0px !important;
    padding: 0px !important;
}

/deep/ .v-input--selection-controls.v-input.checkbox-user .v-input--selection-controls__input {
    margin: auto !important;
}

/deep/ .v-input--selection-controls__input .v-icon {
    font-size: 24px;
}

.rank-name {
    font-weight: 500;
}

.rank-path {
    font-weight: 300;
    font-size: 14px;
}
</style>